<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type='primary' v-if="type === 1 || type === 2" @click="addOrEdit" :loading="btnLoading">保存</el-button>
      <vxe-button type='primary' v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div class="main">
      <el-form ref="ruleForm" :model="friendlink" label-position="right" class="mainfrom from_input">

        <el-form-item label="顺序号" prop="friendlinkseq" verify int>
          <el-input v-model="friendlink.friendlinkseq" :maxlength="6" :disabled="disable"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="friendlinkname">
          <el-input v-model="friendlink.friendlinkname" :maxlength="40" show-word-limit :disabled="disable"></el-input>
        </el-form-item>
        <el-form-item label="网站图标" prop="friendlinkpicpath" verify>
          <upload-pic-one @changed='setPic' :picUrl='friendlink.friendlinkpicpath' text="选择文件"></upload-pic-one>
        </el-form-item>
        <el-form-item label="网站链接" prop="friendlinkurl" verify>
          <el-input v-model="friendlink.friendlinkurl" :maxlength="255" show-word-limit :disabled="disable">
            <!--<template slot="prepend"></template>-->
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  import common from '@/mixin/common'
  import _ from 'lodash'

  const SUCCESS = 1
  export default {
    name: "friendlinkform",
    mixins: [common],
    data () {
      return {
        friendlink: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false
      }
    },
    created () {
    },
    activated () {
      this.init()
    },
    watch: {},
    filters: {},
    components: {uploadPicOne},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      validateFriendLink (rul, val, callback) {
        this.validateData("该名称已存在", 'friendlinkrec', 'friendlinkid', 'friendlinkname', val, callback)
      },
      validateData (msg, tablename, fieldid, checkfield, checkval, callback) {
        request({
          url: '/validate/validateData',
          method: "post",
          data: {
            tablename,
            fieldid,
            checkfield,
            checkval: this.friendlink[checkfield],
            id: this.friendlink.friendlinkid
          }
        }).then(res => {
          res === SUCCESS ? callback(Error(msg)) : callback()
        })
      },
      async init () {
        this.friendlink = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        this.wmenuList = []
      },
      async setPic (path) {
        this.$set(this.friendlink, 'friendlinkpicpath', path.replace(this.uploadAddr, ''))
        // this.friendlink.friendlinkpicpath = path.replace(this.uploadAddr, '')
      },
      async addOrEdit () {
        this.submitForm('ruleForm').then(async() => {
          let data = await request({
            url: '/ywgl/friendlink/addOrEdit',
            method: "post",
            data: this.friendlink
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'friendlinkIndex'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 350px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 690px;
    }
  }
</style>
